/**
 * HTTP 404
 */
export const ERROR_HTTP_404 = 'error_http_404';

/**
 * Неизвестная ошибка
 */
export const ERROR_UNKNOWN_ERROR = 'error_unknown_error';

/**
 * Пользователь существует
 */
export const ERROR_USER_EXIST = 'error_user_exist';

/**
 * Пользователь не существует
 */
export const ERROR_USER_DOES_NOT_EXIST = 'error_user_does_not_exist';

/**
 * Пользователь существует
 */
export const ERROR_USER_WITH_PHONE_NUMBER_EXIST = 'error_user_with_phone_number_exist';

/**
 * Пользователь не существует
 */
export const ERROR_USER_WITH_PHONE_NUMBER_DOES_NOT_EXIST =
  'error_user_with_phone_number_does_not_exist';

/**
 * Пользователь существует
 */
export const ERROR_USER_WITH_EMAIL_EXIST = 'error_user_with_email_exist';

/**
 * Пользователь не существует
 */
export const ERROR_USER_WITH_EMAIL_DOES_NOT_EXIST = 'error_user_with_email_does_not_exist';

/**
 * Пользователь уже авторизован
 */
export const ERROR_USER_AUTHORIZED = 'error_user_authorized';

/**
 * Пользователь еще не авторизован
 */
export const ERROR_USER_IS_NOT_AUTHORIZED = 'error_user_is_not_authorized';

/**
 * Номер телефона не верен
 */
export const ERROR_PHONE_NUMBER_IS_NOT_VALID = 'error_phone_number_is_not_valid';

/**
 * Номер телефона не подтвержден
 */
export const ERROR_PHONE_NUMBER_IS_NOT_CONFIRMED = 'error_phone_number_is_not_confirmed';

/**
 * Номер телефона не существует
 */
export const ERROR_PHONE_NUMBER_DOES_NOT_EXIST = 'error_phone_number_does_not_exist';

/**
 * Email не существует
 */
export const ERROR_EMAIL_DOES_NOT_EXIST = 'error_email_does_not_exist';

/**
 * Email не подтвержден
 */
export const ERROR_EMAIL_IS_NOT_CONFIRMED = 'error_email_is_not_confirmed';

/**
 * Неверный пароль
 */
export const ERROR_PASSWORD_IS_NOT_VALID = 'error_password_is_not_valid';

/**
 * Неверный тип пользователя
 */
export const ERROR_USER_TYPE_IS_NOT_VALID = 'error_user_type_is_not_valid';

/**
 * Код валидации не верен
 */
export const ERROR_SECURITY_CODE_IS_NOT_VALID = 'error_security_code_is_not_valid';

/**
 * Токен валидации не существует
 */
export const ERROR_SECURITY_TOKEN_DOES_NOT_EXIST = 'error_security_token_does_not_exist';

/**
 * Регистрация не завершена успешно
 */
export const ERROR_REGISTRATION_FAILED = 'error_registration_failed';

/**
 * Код ИНН не верен
 */
export const ERROR_INN_IS_NOT_VALID = 'error_inn_is_not_valid';

/**
 * Компания не активна
 */
export const ERROR_COMPANY_IS_NOT_ACTIVE = 'error_company_is_not_active';

/**
 * Компания не зарегистрирована
 */
export const ERROR_COMPANY_IS_NOT_REGISTERED = 'error_company_is_not_registered';

/**
 * Профиль пользователя не подтвержден
 */
export const ERROR_USER_PROFILE_IS_NOT_CONFIRMED = 'error_user_profile_is_not_confirmed';
